export default function getTableRowCountForCells(cells) {
  if (!cells || cells.isEmpty()) {
    return 0;
  }

  var hasPartialLastRow = !cells.last().getIn(['data', 'rowBreak']);
  var rowCount = cells.filter(function (cell) {
    return cell.getIn(['data', 'rowBreak']);
  }).size;
  return hasPartialLastRow ? rowCount + 1 : rowCount;
}